// extracted by mini-css-extract-plugin
module.exports = {"frameWrapper":"styles_frameWrapper__16-Qo","error":"styles_error__3d_tT","mainText":"styles_mainText__3TP7c","text":"styles_text__2Icii"};